// extracted by mini-css-extract-plugin
module.exports = {"fold":"FoldNavItem_fold__3AJUw","unfold":"FoldNavItem_unfold__5TmuK","sub":"FoldNavItem_sub__16nw9","active":"FoldNavItem_active__2eRy-"};